import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';
import { ConfirmationDialogComponent } from '@app/components';
import { EffectiveDate } from '@app/enums/effective-date.enum';
import moment from 'moment/moment';

@Component({
    selector: 'app-policy-change-confirmation-dialog',
    templateUrl: './policy-change-confirmation-dialog.template.html',
    styleUrls: ['./policy-change-confirmation-dialog.style.scss'],
})
export class PolicyChangeConfirmationDialogComponent implements OnInit {
    @Input() timeOffPolicy: TimeOffPolicy;
    @ViewChild('confirmation', { static: true }) confirmation: ConfirmationDialogComponent;

    todayDate = moment(new Date()).format('YYYY-MM-DD');

    todayValue: string = EffectiveDate.today;
    dateHiredValue: string = EffectiveDate.hireDate;

    ngOnInit(): void {
        this.timeOffPolicy.effectiveDate = EffectiveDate.today;
    }

    open(): Promise<boolean> {
        return this.confirmation.open();
    }
}
